module.exports = __webpack_public_path__ + "img/albil-logo.d5831266.svg";